'use client';

import { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';

const REFERRAL_COOKIE_NAME = 'quantwheel_ref';
const COOKIE_MAX_AGE_DAYS = 30;

export function ReferralTracker() {
  const searchParams = useSearchParams();
  
  useEffect(() => {
    const referralCode = searchParams.get('r');
    
    // If a referral code is in the URL, track it
    if (referralCode) {
      // Set client-side cookie immediately as backup
      setClientCookie(referralCode);
      
      // Then track via API (which also sets server-side cookie)
      trackReferralVisit(referralCode);
    }
  }, [searchParams]);
  
  // Set client-side cookie as backup
  const setClientCookie = (code: string) => {
    try {
      // Check if cookie already exists with this code
      const existingCookie = document.cookie
        .split('; ')
        .find(row => row.startsWith(`${REFERRAL_COOKIE_NAME}=`));
      
      if (existingCookie && existingCookie.split('=')[1] === code) {
        // Cookie already exists with this code
        return;
      }
      
      const expires = new Date();
      expires.setDate(expires.getDate() + COOKIE_MAX_AGE_DAYS);
      
      document.cookie = `${REFERRAL_COOKIE_NAME}=${code}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
      console.log('Client-side referral cookie set:', code);
    } catch (error) {
      console.error('Error setting client-side cookie:', error);
    }
  };
  
  // Function to track referral visit via API
  const trackReferralVisit = async (code: string) => {
    try {
      // Check if we've already tracked this visit (via cookie)
      const response = await fetch(`/api/referrals/track?code=${code}`);
      const data = await response.json();
      
      // Log tracking result (for debugging)
      if (data.success && data.tracked) {
        console.log('Referral visit tracked via API:', code);
      } else if (data.success && !data.tracked) {
        console.log('Referral already tracked:', code);
      }
    } catch (error) {
      console.error('Error tracking referral visit via API:', error);
      // Client-side cookie is already set as backup
    }
  };
  
  // This component doesn't render anything
  return null;
} 